import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { MeshGradient } from "../components/AnimatedBackground";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "../i18n";

export function Terms() {
  const { t, lang, switchLanguage } = useLanguage();

  return (
    <div className="relative min-h-screen">
      <div className="noise-overlay" />
      <MeshGradient />
      <Navbar currentPage="legal" />

      <main className="relative z-10 pt-32 pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          {/* Top bar: back + language switch */}
          <div className="flex items-center justify-between mb-8">
            <a
              href="/"
              className="inline-flex items-center gap-2 text-zinc-400 hover:text-white transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              {t.backToHome}
            </a>
            <button
              onClick={() => switchLanguage(lang === "de" ? "en" : "de")}
              className="text-sm text-zinc-500 hover:text-white transition-colors border border-white/10 rounded px-2 py-1"
            >
              {lang === "de" ? "English" : "Deutsch"}
            </button>
          </div>

          {/* Page Header */}
          <div className="mb-12">
            <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">{t.agb.title}</h1>
            <p className="text-zinc-400">{t.agb.subtitle}</p>
          </div>

          {/* Content */}
          <div className="legal-content space-y-8">
            <section>
              <h2>{t.agb.s1Title}</h2>
              <p>{t.agb.s1P1}</p>
            </section>

            <section>
              <h2>{t.agb.s2Title}</h2>
              <p>{t.agb.s2P1}</p>
            </section>

            <section>
              <h2>{t.agb.s3Title}</h2>
              <p>{t.agb.s3P1}</p>
            </section>

            <section>
              <h2>{t.agb.s4Title}</h2>
              <p>{t.agb.s4P1}</p>
            </section>

            <section>
              <h2>{t.agb.s5Title}</h2>
              <p>{t.agb.s5P1}</p>
            </section>

            <section>
              <h2>{t.agb.s6Title}</h2>
              <p>{t.agb.s6P1}</p>
            </section>

            <section>
              <h2>{t.agb.s7Title}</h2>
              <p>{t.agb.s7P1}</p>
              <p>{t.agb.s7P2}</p>
              <p>{t.agb.s7P3}</p>
            </section>

            <section>
              <h2>{t.agb.s8Title}</h2>
              <p>{t.agb.s8P1}</p>
              <p>{t.agb.s8P2}</p>
            </section>

            <section>
              <h2>{t.agb.s9Title}</h2>
              <p>{t.agb.s9P1}</p>
              <p>{t.agb.s9P2}</p>
              <p>{t.agb.s9P3}</p>
            </section>

            <section>
              <h2>{t.agb.s10Title}</h2>
              <p>{t.agb.s10P1}</p>
            </section>

            <section>
              <h2>{t.agb.s11Title}</h2>
              <p>{t.agb.s11P1}</p>
              <p>{t.agb.s11P2}</p>
            </section>

            <section>
              <h2>{t.agb.s12Title}</h2>
              <p>{t.agb.s12P1}</p>
              <p>{t.agb.s12P2}</p>
            </section>

            <section>
              <h2>{t.agb.s13Title}</h2>
              <p>{t.agb.s13P1}</p>
            </section>

            <section>
              <h2>{t.agb.s14Title}</h2>
              <p>{t.agb.s14P1}</p>
              <p>{t.agb.s14P2}</p>
              <p>{t.agb.s14P3}</p>
            </section>

            <section>
              <h2>{t.agb.s15Title}</h2>
              <p>{t.agb.s15P1}</p>
              <p>
                <a href={`mailto:${t.agb.contactEmail}`} className="text-emerald-400 hover:text-emerald-300 transition-colors">
                  {t.agb.contactEmail}
                </a>
              </p>
            </section>
          </div>

          {/* Last updated */}
          <div className="mt-12 pt-8 border-t border-white/10">
            <p className="text-sm text-zinc-500">Last updated: April 2026</p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
